<div class="create-page">
  <div class="create-shell">
    <header class="create-hero">
      <div class="hero-left">
        <div class="hero-icon">
          <i class="fa-solid fa-calendar-check"></i>
          <span class="hero-pulse"></span>
        </div>
        <div class="hero-text">
          <p class="hero-eyebrow">{{ "create.heroEyebrow" | t }}</p>
          <h1 class="hero-title">{{ "create.heroTitle" | t }}</h1>
          <p class="hero-subtitle">{{ "create.heroSubtitle" | t }}</p>
        </div>
      </div>
    </header>

    <section class="create-panel">
      <div class="panel-header">
        <div>
          <h2 class="panel-title">{{ "create.panelTitle" | t }}</h2>
          <p class="panel-subtitle">{{ "create.panelSubtitle" | t }}</p>
        </div>
      </div>

      <div class="selection-row">
        <div class="selection-field">
          <label class="input-label required">{{
            "create.organizationLabel" | t
          }}</label>
          <div class="select-wrap">
            <i class="fa-solid fa-building"></i>
            <ng-select
              class="ng-select-custom"
              [items]="organizations"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedOrganization"
              [clearable]="false"
              [notFoundText]="'common.noRecordsFound' | t"
              [placeholder]="'create.organizationPlaceholder' | t"
              (change)="onOrganizationChange(selectedOrganization)"
            ></ng-select>
          </div>
        </div>
        <div class="selection-field">
          <label class="input-label required">{{
            "create.facilityLabel" | t
          }}</label>
          <div class="select-wrap">
            <i class="fa-solid fa-hospital"></i>
            <ng-select
              class="ng-select-custom"
              [items]="facilities"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedFacility"
              [clearable]="false"
              [disabled]="!selectedOrganization"
              [notFoundText]="'common.noRecordsFound' | t"
              [placeholder]="'create.facilityPlaceholder' | t"
              (change)="onFacilityChange(selectedFacility)"
            ></ng-select>
          </div>
        </div>
        <div class="selection-field">
          <label class="input-label required">{{
            "create.departmentLabel" | t
          }}</label>
          <div class="select-wrap">
            <i class="fa-solid fa-user-doctor"></i>
            <ng-select
              class="ng-select-custom"
              [items]="departments"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedDepartment"
              [clearable]="false"
              [disabled]="!selectedFacility"
              [notFoundText]="'common.noRecordsFound' | t"
              [placeholder]="'create.departmentPlaceholder' | t"
              (change)="onDepartmentChange(selectedDepartment)"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="department-option">
                  <img
                    *ngIf="item?.icon"
                    class="department-option-icon"
                    [src]="'/assets/icons/' + item.icon + '.svg'"
                    [alt]="item?.name"
                  />
                  <span>{{ item?.name }}</span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="department-option">
                  <img
                    *ngIf="item?.icon"
                    class="department-option-icon"
                    [src]="'/assets/icons/' + item.icon + '.svg'"
                    [alt]="item?.name"
                  />
                  <span>{{ item?.name }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="selection-field">
          <label class="input-label required">{{
            "create.doctorLabel" | t
          }}</label>
          <div class="select-wrap">
            <i class="fa-solid fa-user-doctor"></i>
            <ng-select
              class="ng-select-custom"
              [items]="doctors"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedDoctor"
              [clearable]="false"
              [disabled]="!selectedDepartment"
              [notFoundText]="'common.noRecordsFound' | t"
              [placeholder]="'create.doctorPlaceholder' | t"
              (change)="onDoctorChange(selectedDoctor)"
            ></ng-select>
          </div>
        </div>
      </div>

      <div class="calendar-grid">
        <div class="calendar-card">
          <h5>{{ "create.calendarTitle" | t }}</h5>
          <ngb-datepicker
            [(ngModel)]="today"
            [markDisabled]="isDisabled"
            (dateSelect)="dateSelect($event)"
            [showWeekNumbers]="false"
          ></ngb-datepicker>
        </div>
        <div class="time-card">
          <div class="time-header">
            <h6>
              {{
                "create.timeHeader" | t: { date: selectedDateDisplayText }
              }}
            </h6>
            <span class="time-pill">{{ "create.selectableTimes" | t }}</span>
          </div>

          <div
            *ngIf="groupedTimes?.length; else noAvailableTimes"
            class="accordion"
            id="accordionExample"
          >
            <div
              *ngFor="let groupedTime of groupedTimes; let i = index; trackBy: trackByRange"
              class="accordion-item"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  [attr.data-bs-target]="'#collapse' + i"
                  aria-expanded="false"
                  [attr.aria-controls]="'collapse' + i"
                  [disabled]="!hasAvailableTime(groupedTime?.availableTimes)"
                >
                  <div class="accordion-title">
                    <i class="fa-regular fa-clock"></i>
                    <strong>{{ groupedTime?.range || "-" }}</strong>
                  </div>
                </button>
              </h2>
              <div
                [attr.id]="'collapse' + i"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  <div class="time-grid">
                    <div
                      *ngFor="
                        let time of groupedTime.availableTimes;
                        let isLast = last;
                        let i = index;
                        trackBy: trackByHour
                      "
                      (click)="selectTime(time.hour)"
                      class="time-chip"
                      [ngClass]="{
                        disabled:
                          !time.isAvailable || isDisabledTimeButton(time.hour),
                        selected: selectedTime === time.hour,
                      }"
                    >
                      <span>{{ time.hour }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noAvailableTimes>
            <p class="empty-state">{{ "create.noAvailableTimes" | t }}</p>
          </ng-template>

          <div class="time-actions">
            <button
              type="button"
              class="primary-btn"
              (click)="createAppointment()"
              [disabled]="!selectedTime || !selectedDoctor || submitLoading"
            >
              <span>{{ "create.createButton" | t }}</span>
              <i class="fa-solid fa-circle-check"></i>
              <div class="btn-glow"></div>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="bg-orb orb-1"></div>
  <div class="bg-orb orb-2"></div>
  <div class="bg-orb orb-3"></div>
</div>
